import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { DataService } from './data.service';
import { DataValues } from 'src/app/utils/enums/data-values';


@Injectable({
  providedIn: 'root'
})
export class CompanyConfigService {

  private company: any = null;

  constructor(
    private readonly dataService: DataService
  ) {}
  private companyName?: string;

  load(): Observable<void> {

    const storedCompany = localStorage.getItem('company');

    if (storedCompany) {
      this.company = JSON.parse(storedCompany);
      this.applyTheme();
      this.applyFavicon();
      return of(void 0);
    }

    return this.dataService.getCompanyData().pipe(
      tap(response => {
        const company = response.data.company;
        const dataInfo = response.data.dataInfo;
        const whatsAppNumber =
          dataInfo.find(
            (item: any) =>
              item.typeDataName === DataValues.WHATSAPP
          )?.dataValue ?? '';
        const whatsAppMessage =
          dataInfo.find(
            (item: any) =>
              item.typeDataName === DataValues.WHATSAPP_MESSAGE
          )?.dataValue ?? '';

        this.companyName =
          dataInfo.find(
            (item: any) =>
              item.typeDataName === DataValues.COMPANY_NAME
          )?.dataValue ?? '';

        this.company = {
          ...company,
          dataInfo: [...dataInfo],
          whatsAppNumber,
          whatsAppMessage,
          companyName: this.companyName
        };

        localStorage.setItem(
          'company',
          JSON.stringify(this.company)
        );

        this.applyTheme();
        this.applyFavicon();
      }),

      map(() => void 0)
    );
  }

  private applyTheme(): void {
    if (!this.company) {
      return;
    }
    const primary = this.company.primaryColorInfo?.hexadecimal;
    const secondary = this.company.secondaryColorInfo?.hexadecimal;

    if (!primary || !secondary) {
      return;
    }

    const root = document.documentElement;

    root.style.setProperty(
      '--primary-color',
      `#${primary}`
    );

    root.style.setProperty(
      '--secondary-color',
      `#${secondary}`
    );

    if(this.companyName){
      document.title = this.companyName;
    }
  }

  getCompany(): any {
    return this.company;
  }

  private applyFavicon(): void {
    if (!this.company?.companyLogoImage) {
      return;
    }

    let favicon = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement | null;

    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }

    favicon.type = 'image/x-icon';
    favicon.href = this.company.companyLogoImage;
  }
}
